import { create } from "zustand";
import { STORAGE_KEYS } from "~/config/constants";
import type { User, Business } from "~/types/entities";

interface AuthState {
  token: string | null;
  user: User | null;
  business: Business | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  setAuth: (token: string, user: User, business?: Business) => void;
  clearAuth: () => void;
  setLoading: (loading: boolean) => void;
  updateUser: (user: User) => void;
  updateBusiness: (business: Business) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: localStorage.getItem(STORAGE_KEYS.TOKEN),
  user: null,
  business: null,
  isAuthenticated: false,
  isLoading: true,

  setAuth: (token, user, business) => {
    localStorage.setItem(STORAGE_KEYS.TOKEN, token);
    set({
      token,
      user,
      business: business ?? null,
      isAuthenticated: true,
      isLoading: false,
    });
  },

  clearAuth: () => {
    localStorage.removeItem(STORAGE_KEYS.TOKEN);
    set({
      token: null,
      user: null,
      business: null,
      isAuthenticated: false,
      isLoading: false,
    });
  },

  setLoading: (isLoading) => set({ isLoading }),

  updateUser: (user) => set({ user }),

  updateBusiness: (business) => set({ business }),
}));
